import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { SxProps, Theme, useTheme } from '@mui/material';

interface Props {
  rowId: string;
  cells: React.ReactNode[];
  handleRowClick?: (id: string) => void;
}

export default function ReuseableTableRow({
  rowId,
  cells,
  handleRowClick,
}: Props) {
  const theme = useTheme();

  const hoverStyle: SxProps<Theme> = handleRowClick
    ? {
        '&:hover': {
          backgroundColor: theme.palette.lightGrey.main,
          cursor: 'pointer',
        },
      }
    : {};

  return (
    <TableRow
      onClick={() => {
        if (handleRowClick) handleRowClick(rowId);
      }}
      sx={hoverStyle}>
      {cells.map((cell, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <TableCell component="td" scope="row" key={`${rowId}-${index}`}>
          {cell}
        </TableCell>
      ))}
    </TableRow>
  );
}
